import type { CartArticles } from '../../../types/cart';
import { ClientFetch } from '../../fetch/ClientFetch';
import { HTTP_METHODS } from 'utils';

export const readCartArticles = async (): Promise<CartArticles> => {
  const payload = {
    start: 0,
    version: 4,
  };

  return new ClientFetch().makePsiRequest<CartArticles>('shoppingcart.article.read', payload, {
    method: HTTP_METHODS.POST,
  });
};
